var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.element.tpl() == 'divider')?_c('el-divider'):_c(_vm.element.tpl(),_vm._b({tag:"component"},'component',_vm.element.props(),false))}
var staticRenderFns = []

export { render, staticRenderFns }